<template>
  <v-skeleton-loader :loading="loading" :types="skeleton" type="article, actions">
    <v-card class="elevation-1 mb-6 rounded-lg mt-0">
      <v-card-title class="pa-7">
        Hodnoty | Plyn
        <v-spacer></v-spacer>
      </v-card-title>
      <v-card-text class="pa-7">
        <v-row>
          <v-col cols="12">
            <v-row class="pb-6">
              <v-col cols="4" class="py-0">
                <div class="request-label">PSČ</div>
                <div class="request-value mt-2">
                  {{ value.postalCode }}
                </div>
              </v-col>
              <v-col cols="auto" class="py-0">
                <div class="request-label">Distributor</div>
                <div class="request-value mt-2">
                  {{ value.distributor.name }}
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-row class="pb-6">
              <v-col cols="4" class="py-0">
                <div class="request-label">Objekt</div>
                <div class="request-value mt-2">
                  {{ value.area.estate.name }}
                </div>
              </v-col>
              <v-col cols="auto" class="py-0">
                <div class="request-label">Velikost objektu</div>
                <div class="request-value mt-2">
                  <div v-html="value.area.name"></div>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-row class="pb-6">
              <v-col cols="4" class="py-0">
                <div class="request-label">Počet osob</div>
                <div class="request-value mt-2">
                  {{ value.person.name }}
                </div>
              </v-col>
              <v-col cols="auto" class="py-0">
                <div class="request-label">Využití</div>
                <div class="request-value mt-2">
                  {{ value.usages.map((value) => value.name).join() }}
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-row class="pb-6">
              <v-col cols="4" class="py-0">
                <div class="request-label">Spotřeba</div>
                <div class="request-value mt-2">{{ value.consumption }} kWh</div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-divider class="mb-6 mr-3 ml-3"></v-divider>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-row class="pb-6">
              <v-col cols="4" class="py-0">
                <div class="request-label">Současný dodavatel</div>
                <div class="request-value mt-2">
                  {{ value.currentProduct ? value.currentProduct.supplierName : '-' }}
                </div>
              </v-col>
              <v-col cols="auto" class="py-0">
                <div class="request-label">Současný produkt</div>
                <div
                  class="request-value mt-2"
                  v-html="value.currentProduct ? value.currentProduct.name : '-'"
                ></div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-row class="pb-6">
              <v-col cols="4" class="py-0">
                <div class="request-label">Nový dodavatel</div>
                <div class="request-value mt-2">
                  {{ value.product ? value.product.supplierName : '-' }}
                </div>
              </v-col>
              <v-col cols="auto" class="py-0">
                <div class="request-label">Nový produkt</div>
                <div
                  class="request-value mt-2"
                  v-html="value.product ? value.product.name : '-'"
                ></div>
                <div v-if="value.product && value.product.gifts && value.product.gifts.length">
                  <table style="width: 100%">
                    <tr v-for="(gift, indexGift) in value.product.gifts" :key="indexGift">
                      <th align="left" class="mt-2" style="color: #fe4600">
                        {{ gift.name }}
                      </th>
                    </tr>
                  </table>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-row class="pb-6">
              <v-col cols="4" class="py-0">
                <div class="request-label">Cena roční spotřeby</div>
                <div class="request-value mt-2">
                  {{ value.consumptionAnnualPrice ? value.consumptionAnnualPrice + ' Kč' : '-' }}
                </div>
              </v-col>
              <v-col cols="auto" class="py-0">
                <div class="request-label">Sleva za rok</div>
                <div class="request-value mt-2">
                  {{ value.consumptionAnnualSaving ? value.consumptionAnnualSaving + ' Kč' : '-' }}
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-divider class="mb-6 mr-3 ml-3"></v-divider>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-row class="pb-6">
              <v-col cols="4" class="py-0">
                <div class="request-label">EIC</div>
                <div class="request-value mt-2">
                  {{ value.eic ? value.eic : '-' }}
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-row class="pb-6">
              <v-col cols="4" class="py-0">
                <div class="request-label">Datum připojení</div>
                <div class="request-value mt-2">
                  {{
                    value.connectionBegin ? $dayjs(value.connectionBegin).format('D.M.YYYY') : '-'
                  }}
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-row class="pb-6">
              <v-col cols="4" class="py-0">
                <div class="request-label">Typ zákazníka</div>
                <div class="request-value mt-2">
                  {{ value.customerType ? value.customerType.text : '-' }}
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-row class="pb-6">
              <v-col cols="4" class="py-0">
                <div class="request-label">Typ smlouvy</div>
                <div class="request-value mt-2">
                  {{ value.contractType ? value.contractType.text : '-' }}
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-row class="pb-6">
              <v-col cols="4" class="py-0">
                <div class="request-label">Prolongace</div>
                <div class="request-value mt-2">{{ value.renewalPeriodType.text }}</div>
              </v-col>
              <v-col v-if="value.renewalPeriodType.name === 'CERTAIN'" cols="4" class="py-0">
                <div class="request-label">Doba</div>
                <div class="request-value mt-2">
                  {{ value.renewalPeriod }} {{ value.renewalPeriodUnit.text }}
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-row class="pb-6">
              <v-col cols="4" class="py-0">
                <div class="request-label">Datum podpisu smlouvy</div>
                <div class="request-value mt-2">
                  {{ value.contractSigned ? $dayjs(value.contractSigned).format('D.M.YYYY') : '-' }}
                </div>
              </v-col>
              <v-col cols="4" class="py-0">
                <div class="request-label">Datum ukončení smlouvy</div>
                <div class="request-value mt-2">
                  {{ value.contractEnd ? $dayjs(value.contractEnd).format('D.M.YYYY') : '-' }}
                </div>
              </v-col>
              <v-col cols="4" class="py-0">
                <div class="request-label">Podpisová prémie</div>
                <div class="request-value mt-2">
                  {{ value.contractBonus ? value.contractBonus : '-' }}
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-row class="pb-6">
              <v-col cols="4" class="py-0">
                <div class="request-label">Způsob podpisu smlouvy</div>
                <div class="request-value mt-2">
                  {{ value.contractConcludingType ? value.contractConcludingType.text : '-' }}
                </div>
              </v-col>
              <v-col cols="4" class="py-0">
                <div class="request-label">Způsob ukončení smlouvy</div>
                <div class="request-value mt-2">
                  {{ value.contractTerminationType ? value.contractTerminationType.text : '-' }}
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-row class="pb-6">
              <v-col cols="4" class="py-0">
                <div class="request-label">Výpovědní lhůta</div>
                <div class="request-value mt-2">
                  {{ value.terminationPeriod ? value.terminationPeriod : '' }}
                  {{ value.terminationPeriodType ? value.terminationPeriodType.text : '-' }}
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-divider class="mb-6 mr-3 ml-3"></v-divider>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-row class="pb-6">
              <v-col cols="4" class="py-0">
                <div class="request-label">Refundace</div>
                <div class="request-value mt-2">
                  <YesNo :value="value.refund" />
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-row class="pb-6">
              <v-col cols="4" class="py-0">
                <div class="request-label">Výše zálohy</div>
                <div class="request-value mt-2">
                  {{ value.advanceAmount ? value.advanceAmount + ' Kč' : '-' }}
                </div>
              </v-col>
              <v-col cols="4" class="py-0">
                <div class="request-label">Platba záloh</div>
                <div class="request-value mt-2">
                  {{ value.advancePeriod ? value.advancePeriod.text : '-' }}
                </div>
              </v-col>
              <v-col cols="4" class="py-0">
                <div class="request-label">Způsob platby zálohy</div>
                <div class="request-value mt-2">
                  {{ value.advanceType ? value.advanceType.text : '-' }}
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-row class="pb-6">
              <v-col cols="4" class="py-0">
                <div class="request-label">Refundace přeplatků</div>
                <div class="request-value mt-2">
                  {{
                    value.bankAccountNumber ? value.bankAccountNumber + '/' + value.bankCode : '-'
                  }}
                </div>
              </v-col>
              <v-col cols="4" class="py-0">
                <div class="request-label">Číslo SIPO</div>
                <div class="request-value mt-2">
                  {{ value.sipoNumber ? value.sipoNumber : '-' }}
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-divider class="mb-6 mr-3 ml-3"></v-divider>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-row class="pb-6">
              <v-col cols="4" class="py-0">
                <div class="request-label">Typ změny dodavatele</div>
                <div class="request-value mt-2">
                  {{ value.supplierChangeType ? value.supplierChangeType.text : '-' }}
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-row class="pb-6">
              <v-col cols="4" class="py-0">
                <div class="request-label">Dodavatel - číselník Yello</div>
                <div class="request-value mt-2">
                  {{ value.dataSentenceSupplierName ? value.dataSentenceSupplierName : '-' }}
                </div>
              </v-col>
              <v-col cols="4" class="py-0">
                <div class="request-label">Product - číselník Yello</div>
                <div class="request-value mt-2">
                  {{ value.dataSentenceProduct ? value.dataSentenceProduct : '-' }}
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-divider class="mb-6 mr-3 ml-3"></v-divider>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-row class="pb-6">
              <v-col cols="4" class="py-0">
                <div class="request-label">Faktura (PDF)</div>
                <div class="request-value mt-2">
                  <YesNo :value="value.invoicePdf" />
                </div>
              </v-col>
              <v-col cols="4" class="py-0">
                <div class="request-label">Faktura (PDF) - email</div>
                <div class="request-value mt-2">
                  {{ value.invoicePdfEmail ? value.invoicePdfEmail : '-' }}
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-divider class="mb-6 mr-3 ml-3"></v-divider>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-row class="pb-6">
              <v-col cols="4" class="py-0">
                <div class="request-label">Poskytování služby - okamžitě</div>
                <div class="request-value mt-2">
                  <YesNo :value="value.serviceProvideImmediately" />
                </div>
              </v-col>
              <v-col cols="4" class="py-0">
                <div class="request-label">Místo služby, odkud zákazník podepisuje</div>
                <div class="request-value mt-2">
                  {{ value.serviceProvideCity ? value.serviceProvideCity : '-' }}
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-divider class="mb-6 mr-3 ml-3"></v-divider>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-row class="pb-6">
              <v-col cols="4" class="py-0">
                <div class="request-label">GDPR</div>
                <div class="request-value mt-2">
                  <YesNo :value="value.gdpr" />
                </div>
              </v-col>
              <v-col cols="4" class="py-0">
                <div class="request-label">MKT</div>
                <div class="request-value mt-2">
                  <YesNo :value="value.marketing" />
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-card-title class="px-0 pb-12 pt-7">
          Čestné prohlášení
          <v-spacer></v-spacer>
        </v-card-title>
        <v-row>
          <v-col cols="12">
            <v-row class="pb-6">
              <v-col cols="4" class="py-0">
                <div class="request-label">Dne</div>
                <div class="request-value mt-2">
                  {{
                    value.affidavitCustomerDate
                      ? $dayjs(value.affidavitCustomerDate).format('D.M.YYYY')
                      : '-'
                  }}
                </div>
              </v-col>
              <v-col cols="4" class="py-0">
                <div class="request-label">Zemřel</div>
                <div class="request-value mt-2">
                  <YesNo :value="value.affidavitCustomerDied" />
                </div>
              </v-col>
              <v-col cols="4" class="py-0">
                <div class="request-label">Trvale opustil odběrné místo</div>
                <div class="request-value mt-2">
                  <YesNo :value="value.affidavitCustomerLeft" />
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="pl-7 pr-7 pb-7">
        <v-spacer></v-spacer>
        <template>
          <v-btn
            type="submit"
            height="40px"
            min-width="130px"
            color="primary"
            depressed
            :to="{ name: 'orders.edit', params: { id: this.$route.params.id } }"
          >
            Editovat
          </v-btn>
        </template>
      </v-card-actions>
    </v-card>
    <AddressDetail
      v-if="value.address"
      :id="value.address.id"
      v-model="value.address"
      :order-id="id"
      :order="true"
      title="Adresa odběrného místa"
    />
  </v-skeleton-loader>
</template>
<script>
import AddressDetail from '@/views/pages/address/AddressDetail'
import YesNo from '../../../components/YesNo.vue'

export default {
  name: 'OrderGasDetail',
  components: { YesNo, AddressDetail },
  props: {
    value: {
      type: Object,
      required: true,
    },
    id: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      skeleton: {
        article: 'heading, paragraph@2',
      },
      order: {},
      loading: false,
      saving: false,
    }
  },
}
</script>
